import React, { Component } from 'react'
import AWSAPI from '../../../../common/AWSAPI'
import Config from '../../../../Config'

/*
* これを継承したコンポーネントでは必ずthis.apiUrlをconstructorで設定すること
*/

class CognitoUserManagement extends Component {
  updateCognitoUser (cognitoUser, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'update',
      username: cognitoUser.id,
      customAttributes: {
        Email: cognitoUser.email,
        Name: cognitoUser.name,
        ParentId: cognitoUser.parentID,
        emailNotification: cognitoUser.emailNotification,
        prefectures: cognitoUser.prefectures,
        branch: cognitoUser.branch,
        administrator: cognitoUser.administrator,
        isMember: cognitoUser.isMember,
        approvalFlg: cognitoUser.approvalFlg,
        oldApprovalFlg: cognitoUser.oldApprovalFlg,
      }
    }
    //console.log("Request Parameters:", params);
    AWSAPI.apiPost('admin', this.apiUrl, params, (response) => {
      //console.log("API Response:", response);
      onSuccess(response);
    });
  }
  addCognitoUser (cognitoUser, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'add',
      username: this.uuid(),
      customAttributes: {
        Email: cognitoUser.email,
        Name: cognitoUser.name,
        ParentId: cognitoUser.parentID ? cognitoUser.parentID : '',
        emailNotification: cognitoUser.emailNotification,
        prefectures: cognitoUser.prefectures,
        branch: cognitoUser.branch,
        administrator: cognitoUser.administrator,
        isMember: cognitoUser.isMember,
        approvalFlg: 'true'
      }
    }
    //console.log("Request Parameters:", params);
    AWSAPI.apiPost('admin', this.apiUrl, params, (response) => {
      //console.log("API Response:", response);
      onSuccess(response);
    });
  }
  deleteCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'delete',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('admin', this.apiUrl, params)
  }
  disableCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'disable',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('admin', this.apiUrl, params)
  }
  enableCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'enable',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('admin', this.apiUrl, params)
  }
  getCognitoUsersListCount (searchData, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'count',
      searchName: searchData.searchName ? searchData.searchName : '',
      searchBranch: searchData.searchBranch ? searchData.searchBranch : '',
      searchPrefectures: searchData.searchPrefectures ? searchData.searchPrefectures : '',
      searchMember: searchData.searchMember,
      searchNonMember: searchData.searchNonMember,
      searchUnapproved: searchData.searchUnapproved,
      searchDateStart: searchData.searchDateStart ? searchData.searchDateStart : '',
      searchDateEnd: searchData.searchDateEnd ? searchData.searchDateEnd : '',
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.hasOwnProperty('Users')) {
          if (onSuccess) onSuccess(res.body.Users)
        }
      }
    )
  }
  loadCognitoUsersCount (searchData = []) {
    const onSuccess = (res) => {
      const userCount = res
      this.setState({
        userCount: userCount
      })
    }
    this.getCognitoUsersListCount(searchData, onSuccess)
  }
  getCognitoUsers (onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'list'
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.hasOwnProperty('Users')) {
          if (onSuccess) onSuccess(res.body.Users)
        }
      }
    )
  }
  getCognitoUsersPerPage (pageNumber, pazeSize, searchData, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'perpage',
      pageSize: pazeSize,
      pageNumber: pageNumber,
      searchName: searchData.searchName ? searchData.searchName : '',
      searchBranch: searchData.searchBranch ? searchData.searchBranch : '',
      searchPrefectures: searchData.searchPrefectures ? searchData.searchPrefectures : '',
      searchMember: searchData.searchMember,
      searchNonMember: searchData.searchNonMember,
      searchUnapproved: searchData.searchUnapproved,
      searchDateStart: searchData.searchDateStart ? searchData.searchDateStart : '',
      searchDateEnd: searchData.searchDateEnd ? searchData.searchDateEnd : '',
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.hasOwnProperty('Users')) {
          if (onSuccess) onSuccess(res.body.Users)
        }
      }
    )
  }
  getCognitoUser (id, onSuccess, withLogs = false, onFailure) {
    const params = {
      userRole: this.userRole,
      command: 'get',
      username: id
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (withLogs) {
          if (onSuccess) onSuccess(res.body.userData, res.body.logs)
        } else {
          if (onSuccess) onSuccess(res.body.userData)
        }
      },
      (res) => {
        // 取得失敗時も呼び出し元へ通知し、処理が止まらないようにする。
        // ※ 従来は onFailure 未指定で、apiPost が失敗判定した瞬間に
        //   コールバックが一切発火せず、一覧が無限ロードになっていた(NKK-158)。
        if (onFailure) onFailure(res)
      }
    )
  }
  getCognitoCompanyUserCount (id, onSuccess, withLogs = false) {
    const params = {
      userRole: this.userRole,
      command: 'usercount',
      username: id
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        try {
          const body = typeof res.body === 'string' ? JSON.parse(res.body) : res.body;
          if (body && body.hasOwnProperty('Users')) {
            onSuccess(null, { Users: body.Users });
          } else {
            onSuccess(new Error('結果が取得できませんでした'), null);
          }
        } catch (e) {
          onSuccess(undefined);
        }
      }
    )
  }
  getCognitoCompanyUserCountPromise(parentId) {
    return new Promise((resolve, reject) => {
      this.getCognitoCompanyUserCount(parentId, (err, result) => {
        if (result === undefined) {
          reject(new Error('結果が取得できませんでした'));
        } else {
          resolve(result);
        }
      });
    });
  }
  getAllUsersLoginInfo(onSuccess) {
    this.getCognitoUsers( (users) => {
      const usersLoginInfo = [];
      let processedCount = 0;

      users.forEach((user) => {
        this.getCognitoUser(user.Username, async (userData, logs) => {
          // custom:ParentID を取得
          const parentIDAttr = (userData.UserAttributes || []).find(attr => attr.Name === 'custom:ParentID');
          const parentId = parentIDAttr ? parentIDAttr.Value : null;

          let companyUserCount = 0;

          usersLoginInfo.push({
            userData,
            logs: logs || [],
            companyUserCount: companyUserCount
          });

          processedCount++;
          if (processedCount === users.length) {
            if (onSuccess) onSuccess(usersLoginInfo);
          }
        }, true);
      });
    });
  }
  getAllUsersLoginInfoPerPage(pageNumber, pageSize, searchData, onSuccess) {
    this.getCognitoUsersPerPage(pageNumber, pageSize, searchData, (users) => {
      const usersLoginInfo = [];
      if (users.length === 0) {
        if (onSuccess) onSuccess([]);  // 0件でも空配列でコールバック
        return;
      }
      let processedCount = 0;

      // 成功・失敗いずれの場合も必ず呼び、全件処理し終えたら onSuccess を発火する。
      // ※ 1件でも未完了だと一覧が「サーバからデータを取得中」のまま停止するため(NKK-158)、
      //   途中で失敗しても取得できた分で描画する。
      const finalize = () => {
        processedCount++;
        if (processedCount === users.length) {
          if (onSuccess) onSuccess(usersLoginInfo);
        }
      };

      users.forEach((user) => {
        this.getCognitoUser(user.Username, async (userData, logs) => {
          // username を取得
          const parentId = userData.Username;

          let companyUserCount = 0;

          if (parentId) {
            try {
              const result = await this.getCognitoCompanyUserCountPromise(parentId);
              if (result && result.Users) {
                companyUserCount = result.Users;
              }
            } catch (err) {
              console.error('件数取得エラー:', err);
            }
          }

          usersLoginInfo.push({
            userData,
            logs: logs || [],
            companyUserCount: companyUserCount
          });

          finalize();
        }, true, (err) => {
          console.error('ユーザー情報取得エラー:', user.Username, err);
          finalize();
        });
      });
    });
  }
  getStatusCaption (code) {
    switch (code) {
      case 'CONFIRMED':
        return 'ログイン済'
      case 'FORCE_CHANGE_PASSWORD':
        return '未ログイン'
      default:
        return code
    }
  }
  getUserDataEmail (email, onSuccess) {
    const params = {
      userRole: 'companyUser',
      command: 'mail',
      email: email,
    }
    console.log("Request Parameters:", params);
    AWSAPI.apiPost('admin', this.apiUrl, params, (response) => {
        console.log("API Response:", response);
        onSuccess(response);
    });
  }
  inheritingEstimationData (baseUserId, basecompanyId, userId, companyId, onSuccess) {
    const params = {
      command: 'inheriting',
      baseUserId: baseUserId,
      basecompanyId: basecompanyId,
      userId: userId,
      companyId: companyId,
    }
    console.log("Request Parameters:", params);
    AWSAPI.apiPost('admin', Config.adminApiUrl.estimation, params, (response) => {
        console.log("API Response:", response);
        onSuccess(response);
    });
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  utc2jst (datetime) {
    let dt = new Date(datetime)
    return dt.toLocaleString()
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  arrayGet (array, name, defaultValue = '') {
    if (array && Array.isArray(array)) {
      const result = array.find((e) => e.Name === name);
      if (result) {
        return result.Value;
      }
    }
    return defaultValue;
  }
}
export default CognitoUserManagement



// WEBPACK FOOTER //
// ./src/admin/pages/secure/abstract/CognitoUserManagement.js